import { Flex, TagFilledIcon, Typography } from '@iheartjane/reefer';
import type { CSSProperties } from 'react';

import { useHeadlessApp } from '@jane/shared/providers';

export const SpecialsTag = ({
  title,
  bloomUserExperience,
}: {
  bloomUserExperience?: boolean;
  title: string;
}) => {
  const { options } = useHeadlessApp();
  const specialBadgeColor = (
    options?.theme as { specialBadgeColor?: string } | undefined
  )?.specialBadgeColor;

  const content = (
    <Flex alignItems="center">
      <TagFilledIcon size="sm" color="info" />
      <Typography color={bloomUserExperience ? 'text-main' : 'info'} ml={4}>
        {title}
      </Typography>
    </Flex>
  );

  if (specialBadgeColor) {
    return (
      <span
        style={{ '--colors-info-main': specialBadgeColor } as CSSProperties}
      >
        {content}
      </span>
    );
  }

  return content;
};
